import { render, staticRenderFns } from "./SendSms.vue?vue&type=template&id=1d89e756&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"
import style0 from "./SendSms.vue?vue&type=style&index=0&id=1d89e756&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89e756",
  null
  
)

export default component.exports